// for employee information
export const CUSTOMER_INFO = "customer_info";
export const CUSTOMER_INFO_SUCCESS = "customer_info_success";
export const CUSTOMER_INFO_FAILURE = "customer_info_failure";
export const RESET_CUSTOMER_INFO = "reset_customer_info";


